import api from './api';
import { Product } from './productService';
import { Review } from './reviewService';

export interface Seller {
  id: string;
  email: string;
  name: string | null;
  role: string;
  avatar: string | null;
  isEmailVerified: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface SellerProfile {
  seller: Seller;
  products: Product[];
  reviews: Review[];
  stats: {
    totalProducts: number;
    totalReviews: number;
    averageRating: number;
    totalSales: number;
  };
}

export const sellerService = {
  /**
   * Get seller profile with products and reviews
   */
  async getSellerProfile(sellerId: string): Promise<SellerProfile> {
    const response = await api.get(`/auth/seller/${sellerId}`);
    return response.data;
  },
};

